export { default } from "./routes/media/home.tsx";